import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=5bdc34bf&scoped=true&"
import script from "./Performance.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Performance.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Performance.vue?vue&type=style&index=0&id=5bdc34bf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdc34bf",
  null
  
)

export default component.exports